import { RideComputedDataKeys } from "../../constants";
import { ILiveMapGridToolbarStats } from "../../models";

type TRideSearchRowWithLiveMapStats = {
  computedData?: {
    [RideComputedDataKeys.liveMapStats]?: ILiveMapGridToolbarStats;
  };
};

/** Reads toolbar counters from the first live-map search row (`computedData.liveMapStats`). */
export const getLiveMapStatsFromRideSearchRows = (
  rows: readonly TRideSearchRowWithLiveMapStats[] | undefined,
): ILiveMapGridToolbarStats | undefined =>
  rows?.[0]?.computedData?.[RideComputedDataKeys.liveMapStats];
